/**
 * User API client for broker / reseller / owner roles.
 * Shares the axios instance from `./api.js` so interceptors stay consistent.
 */
import { api } from './api';

const TOKEN_KEY = 'zircon_user_token';
const USER_KEY = 'zircon_user';

export function getUserToken() {
    try { return localStorage.getItem(TOKEN_KEY) || ''; } catch (_e) { return ''; }
}

export function setUserToken(token) {
    try { localStorage.setItem(TOKEN_KEY, token); } catch (_e) { /* ignore */ }
}

export function clearUserSession() {
    try {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
    } catch (_e) { /* ignore */ }
}

export function getCachedUser() {
    try {
        const raw = localStorage.getItem(USER_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (_e) { return null; }
}

export function cacheUser(user) {
    try { localStorage.setItem(USER_KEY, JSON.stringify(user)); } catch (_e) { /* ignore */ }
}

function authHeaders() {
    const t = getUserToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
}

// ---- OTP ----
export async function sendOtp(phone) {
    const r = await api.post('/auth/otp/send', { phone });
    return r.data;
}

export async function verifyOtp(phone, code) {
    const r = await api.post('/auth/otp/verify', { phone, code });
    return r.data;
}

// ---- Register / Login ----
export async function registerUser(payload) {
    const r = await api.post('/auth/register', payload);
    if (r.data?.access_token) {
        setUserToken(r.data.access_token);
        if (r.data.user) cacheUser(r.data.user);
    }
    return r.data;
}

export async function loginUser(email, password) {
    const r = await api.post('/auth/login', { email, password });
    if (r.data?.access_token) {
        setUserToken(r.data.access_token);
        if (r.data.user) cacheUser(r.data.user);
    }
    return r.data;
}

export async function fetchMe() {
    const r = await api.get('/auth/me', { headers: authHeaders() });
    cacheUser(r.data);
    return r.data;
}

// ---- File upload (multipart) ----
export async function uploadUserDoc(file, category /* 'profile_photo' | 'ownership_proof' */) {
    const fd = new FormData();
    fd.append('file', file);
    fd.append('category', category);
    const r = await api.post('/uploads/user-doc', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 60000,
    });
    return r.data;
}

// ---- Resolve uploaded URL relative to backend ----
import { BACKEND_URL } from './config';
export function resolveUploadUrl(url) {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    return `${BACKEND_URL}${url}`;
}
